/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventalreadypublishederror3Inputs */

const en_eventalreadypublishederror3 = /** @type {(inputs: Eventalreadypublishederror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This event has already been published.`)
};

const de_eventalreadypublishederror3 = /** @type {(inputs: Eventalreadypublishederror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Event wurde schon veröffentlicht.`)
};

/**
* | output |
* | --- |
* | "This event has already been published." |
*
* @param {Eventalreadypublishederror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventalreadypublishederror3 = /** @type {((inputs?: Eventalreadypublishederror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventalreadypublishederror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventalreadypublishederror3(inputs)
	return de_eventalreadypublishederror3(inputs)
});
export { eventalreadypublishederror3 as "eventAlreadyPublishedError" }